export const serializeError = (e: unknown) =>
  e instanceof Error ? { message: e.message, stack: e.stack } : e
